import { zIndex } from 'constants/zIndex';
import React from 'react';
import { Box, Container } from '@landr/maestro';
import { MainNavigation } from 'components/Navigations';
import Wrapper from 'components/CommonUi/Wrapper';
import { useExecutionEnvironmentContext } from 'contexts/ExecutionEnvironmentContext/ExecutionEnvironmentContext';
import { useAuthentication } from 'contexts/AuthenticationProvider/AuthenticationProvider';

const AppNavigation: React.FC = () => {
    const { isAuthenticated } = useAuthentication();
    const { isDAWPlugin } = useExecutionEnvironmentContext();

    if (isDAWPlugin && !isAuthenticated) {
        return null;
    }

    return (
        <Box zIndex={zIndex.mainNavigation} position="relative">
            <Wrapper>
                <Container>
                    <MainNavigation />
                </Container>
            </Wrapper>
        </Box>
    );
};

export default AppNavigation;
